import { BufferAttribute, BufferGeometry, Mesh } from 'three';

/*
Step 1.
Render just black boxes
Step 2.
Render text with no special shader
Step 3.
Add correct shader for text
*/

/*
    TextHelper uses SDF to render text, but rather than creating one object per string, it
    uses a mesh made of rectangles, where each rectangle is one character, and multiple strings can be
    rendered using the same object.
*/

class ThreeTextHelper extends Mesh {
    constructor({ font }) {
        if (!font) {
            throw new Error('ThreeTextHelper needs a font in its constructor');
        }

        const geometry = new BufferGeometry();
        const fontMaterial = font.getMaterial();

        super(geometry, fontMaterial);

        this.font = font;
        this.clear();
    }

    clear() {
        this.textVertices = [];
        this.textUv = [];
        this.textIndices = [];
        this.textOffsets = [];
        this.textColors = [];
    }

    addText({
        targetBox,
        alignmentX,
        alignmentY,
        text,
        color,
        alpha,
        fontSize,
        z,
        rotate,
    }) {
        const result = this.font.addText({
            alignmentX,
            alignmentY,
            alpha,
            color,
            colors: this.textColors,
            indices: this.textIndices,
            offsets: this.textOffsets,
            rotate,
            size: fontSize,
            targetBox,
            text,
            uv: this.textUv,
            vertices: this.textVertices,
            z,
        });

        return result;
    }
    updateGeometry() {
        const newVertexBuffer = new Float32Array(this.textVertices);
        const newUVBuffer = new Float32Array(this.textUv);
        const newColors = new Float32Array(this.textColors);
        const newOffsetBuffer = new Float32Array(this.textOffsets);
        const newIndices = new Uint16Array(this.textIndices);
        const geometry = this.geometry;

        geometry.setAttribute(
            'position',
            new BufferAttribute(newVertexBuffer, 3),
        );
        geometry.setAttribute('uv', new BufferAttribute(newUVBuffer, 2));
        geometry.setAttribute(
            'offset',
            new BufferAttribute(newOffsetBuffer, 2),
        );
        geometry.setAttribute('color', new BufferAttribute(newColors, 4));
        geometry.setIndex(new BufferAttribute(newIndices, 1));
        geometry.attributes.position.needsUpdate = true;
        geometry.attributes.uv.needsUpdate = true;
        geometry.attributes.offset.needsUpdate = true;
        geometry.index.needsUpdate = true;
    }
}

export default ThreeTextHelper;
